module.exports = __webpack_public_path__ + "static/img/department.3f38d283.png";